import { render } from "./MenuBarLeft.vue?vue&type=template&id=436f63d9&scoped=true"
import script from "./MenuBarLeft.vue?vue&type=script&lang=js"
export * from "./MenuBarLeft.vue?vue&type=script&lang=js"

import "./MenuBarLeft.vue?vue&type=style&index=0&id=436f63d9&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436f63d9"]])

export default __exports__